import React from "react";

export const Image = ({ title, largeImage, smallImage }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={largeImage} target="_blank" title={title} rel="noreferrer" data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} rel="noreferrer" style={{ width: "40rem", height: "20rem", margin: "10px" }} />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
